import designTokens from '@customink/design-tokens/build/ci_light/js/designTokens';
var themeOptions = function () { return ({
    components: {
        MuiAccordion: {
            defaultProps: {
                disableGutters: false,
                square: true,
                sx: { boxShadow: 0 },
            },
            styleOverrides: {
                root: {
                    backgroundColor: '#F8F8F8',
                },
            },
        },
        MuiAccordionSummary: {
            styleOverrides: {
                root: {
                    fontSize: designTokens.typography.heading.sub.size.value,
                },
            },
        },
        MuiAccordionDetails: {
            styleOverrides: {
                root: {
                    fontSize: designTokens.typography.caption.captionSmall.size.value,
                },
            },
        },
    },
}); };
export default themeOptions;
//# sourceMappingURL=accordionTheme.js.map